import { render } from "./TalentMenagementEng.vue?vue&type=template&id=625ae7cd&scoped=true&lang=html"
import script from "./TalentMenagementEng.vue?vue&type=script&lang=js"
export * from "./TalentMenagementEng.vue?vue&type=script&lang=js"

import "./TalentMenagementEng.vue?vue&type=style&index=0&id=625ae7cd&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-625ae7cd"

export default script